import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http'; // Import HttpClient
import { Router } from '@angular/router';
import { ApiService } from 'src/app/shared/services/api.service';
import { UserService } from 'src/app/shared/services/user.service';
import { AppConstants } from 'src/app/shared/constants/app.contants';
import { BaseResponseDTO } from 'src/app/core/models/app.models';
import { FormValidationService } from 'src/app/shared/services/form-validation.service';
import { LoaderService } from 'src/app/shared/services/loader.service';
import { lastValueFrom } from 'rxjs';
import { environment } from 'src/environments/environment';
import { AuthenticationActions } from 'src/app/modules/authentication/components/models/authentication-actions.enum';
// import { TenderAttachmentDialogComponent } from 'src/app/modules/tender/components/tenders/tender-attachment-dialog/tender-attachment-dialog.component';

@Injectable({
  providedIn: 'root'
})
export class VendorService {

  constructor(
    private _router: Router,
    private _userService: UserService,
    private formValidationService: FormValidationService,
    private _loaderService: LoaderService,
    private _http: HttpClient // Inject HttpClient here
  ) {}

  public createVendor() {
    this._loaderService.showLoader();
    const apiService = this.createApiService(); // Create the API service instance
    const payload = this.prepareValidateUserRequestPayload(this._userService.getRegistrationData()); // Get payload using getter
  
    this.fireValidateUserRequest(apiService, payload)
      .then((response: any) => {
        let result = response as unknown as BaseResponseDTO;
        if (result.isSuccess) {
          // Determine the success route and message based on some internal logic
          
  
          // this._router.navigate(
          //   [AppConstants.ROUTES.AUTHENTICATION, AppConstants.ROUTES.SUCCESS],
          //   { state: { message: 'Registration Successful' } }
          // );


          this._router.navigate(
            [AppConstants.ROUTES.AUTHENTICATION, AppConstants.ROUTES.OTP_Page], 
            { queryParams: { action: AuthenticationActions.VerifyEmail } }
          );

   

        } else {
          this.formValidationService.setCustomError(this._userService.getRegistrationData().Mobile, result.errorMessageEn);
        }
      })
      .catch((err: HttpErrorResponse) => {
        this._loaderService.hideLoader();
        // Handle error state
      })
      .finally(() => {
        this._loaderService.hideLoader();
      });
  }

  private createApiService(): ApiService {
    const apiService = new ApiService(this._http);
    apiService['_baseUrl'] = environment.API_URL; // Set the base URL manually
    return apiService;
  }

  private prepareValidateUserRequestPayload(data: any) {
    return data; // Adjust this based on your actual payload requirements
  }

  private fireValidateUserRequest(apiService: ApiService, payload: any) {
    const req$ = apiService.post(
      AppConstants.CONTROLLERS.VENDOR,
      AppConstants.ACTIONS.CreateVendor,
      true,
      environment.APIs_PREFIX,
      payload
    );
    return lastValueFrom(req$);
  }


  public async fetchDocuments(queryDto: { processName: string; processID: string }): Promise<any[]> {
    const apiService = this.createApiService();
    this._loaderService.showLoader();
  
    try {
      // Make the API call with POST and query DTO as the body
      const req$ = apiService.post(
        AppConstants.CONTROLLERS.Documents,
        AppConstants.ACTIONS.GetDocuments,
        true,
        environment.APIs_PREFIX,
        queryDto // Pass the query DTO as the request body
      );
  
      const response: any = await lastValueFrom(req$);
  
      // Return the documents array from the response
      return response?.data || []; // Adjust based on the response structure
    } catch (error) {
      console.error('Failed to fetch documents:', error);
      throw error; // Rethrow error to handle it in the caller method
    } finally {
      this._loaderService.hideLoader();
    }
  }
  



  
}
